/* tslint:disable */
import {
  AccessToken,
  Role,
  CompanyAccount,
  PropertyUnits,
  TenantUnit,
  CheckList,
  TenantDeposit,
  VendorCategories,
  Lease,
  LandlordDetails,
  RoleMapping
} from '../index';

declare var Object: any;
export interface UserProfileInterface {
  "first_name"?: string;
  "last_name"?: string;
  "company_name"?: string;
  "is_company"?: boolean;
  "email"?: string;
  "account_status"?: boolean;
  "personal_phone_number"?: string;
  "other_phone_number"?: string;
  "profile_type"?: string;
  "identification_document"?: string;
  "identification_document_number"?: string;
  "date_of_birth"?: string;
  "postal_address"?: string;
  "physical_address"?: string;
  "emergency_contact_name"?: string;
  "emergency_contact_relationship"?: string;
  "emergency_contact_phone"?: string;
  "emergency_contact_email"?: string;
  "employment_status"?: string;
  "occupation"?: string;
  "employment_company_name"?: string;
  "employment_address"?: string;
  "employment_tel_number"?: string;
  "employment_location"?: string;
  "marital_status"?: string;
  "no_of_children"?: string;
  "referer_name"?: string;
  "referer_contact"?: string;
  "next_of_kin_name"?: string;
  "next_of_kin_relationship"?: string;
  "next_of_kin_tel_number"?: string;
  "next_of_kin_address"?: string;
  "current_landlord_name"?: string;
  "current_landlord_phone_number"?: string;
  "current_landlord_address"?: string;
  "bank_name"?: string;
  "account_number"?: string;
  "kra_pin"?: string;
  "user_category"?: string;
  "realm"?: string;
  "username"?: string;
  "emailVerified"?: boolean;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "password"?: string;
  accessTokens?: AccessToken[];
  roles?: Role[];
  land_lord_properties?: CompanyAccount[];
  property_units?: PropertyUnits[];
  properties?: CompanyAccount[];
  tenant_unit?: TenantUnit[];
  tenants_check_list?: CheckList[];
  tenant_deposit?: TenantDeposit[];
  vendorCategories?: VendorCategories;
  tenantLease?: Lease[];
  landlordDetails?: LandlordDetails;
  roleMappings?: RoleMapping[];
}

export class UserProfile implements UserProfileInterface {
  "first_name": string;
  "last_name": string;
  "company_name": string;
  "is_company": boolean;
  "email": string;
  "account_status": boolean;
  "personal_phone_number": string;
  "other_phone_number": string;
  "profile_type": string;
  "identification_document": string;
  "identification_document_number": string;
  "date_of_birth": string;
  "postal_address": string;
  "physical_address": string;
  "emergency_contact_name": string;
  "emergency_contact_relationship": string;
  "emergency_contact_phone": string;
  "emergency_contact_email": string;
  "employment_status": string;
  "occupation": string;
  "employment_company_name": string;
  "employment_address": string;
  "employment_tel_number": string;
  "employment_location": string;
  "marital_status": string;
  "no_of_children": string;
  "referer_name": string;
  "referer_contact": string;
  "next_of_kin_name": string;
  "next_of_kin_relationship": string;
  "next_of_kin_tel_number": string;
  "next_of_kin_address": string;
  "current_landlord_name": string;
  "current_landlord_phone_number": string;
  "current_landlord_address": string;
  "bank_name": string;
  "account_number": string;
  "kra_pin": string;
  "user_category": string;
  "realm": string;
  "username": string;
  "emailVerified": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "password": string;
  accessTokens: AccessToken[];
  roles: Role[];
  land_lord_properties: CompanyAccount[];
  property_units: PropertyUnits[];
  properties: CompanyAccount[];
  tenant_unit: TenantUnit[];
  tenants_check_list: CheckList[];
  tenant_deposit: TenantDeposit[];
  vendorCategories: VendorCategories;
  tenantLease: Lease[];
  landlordDetails: LandlordDetails;
  roleMappings: RoleMapping[];
  constructor(data?: UserProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserProfile`.
   */
  public static getModelName() {
    return "UserProfile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserProfile for dynamic purposes.
  **/
  public static factory(data: UserProfileInterface): UserProfile{
    return new UserProfile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserProfile',
      plural: 'UserProfiles',
      path: 'UserProfiles',
      idName: 'id',
      properties: {
        "first_name": {
          name: 'first_name',
          type: 'string'
        },
        "last_name": {
          name: 'last_name',
          type: 'string'
        },
        "company_name": {
          name: 'company_name',
          type: 'string'
        },
        "is_company": {
          name: 'is_company',
          type: 'boolean'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "account_status": {
          name: 'account_status',
          type: 'boolean'
        },
        "personal_phone_number": {
          name: 'personal_phone_number',
          type: 'string'
        },
        "other_phone_number": {
          name: 'other_phone_number',
          type: 'string'
        },
        "profile_type": {
          name: 'profile_type',
          type: 'string'
        },
        "identification_document": {
          name: 'identification_document',
          type: 'string'
        },
        "identification_document_number": {
          name: 'identification_document_number',
          type: 'string'
        },
        "date_of_birth": {
          name: 'date_of_birth',
          type: 'string'
        },
        "postal_address": {
          name: 'postal_address',
          type: 'string'
        },
        "physical_address": {
          name: 'physical_address',
          type: 'string'
        },
        "emergency_contact_name": {
          name: 'emergency_contact_name',
          type: 'string'
        },
        "emergency_contact_relationship": {
          name: 'emergency_contact_relationship',
          type: 'string'
        },
        "emergency_contact_phone": {
          name: 'emergency_contact_phone',
          type: 'string'
        },
        "emergency_contact_email": {
          name: 'emergency_contact_email',
          type: 'string'
        },
        "employment_status": {
          name: 'employment_status',
          type: 'string'
        },
        "occupation": {
          name: 'occupation',
          type: 'string'
        },
        "employment_company_name": {
          name: 'employment_company_name',
          type: 'string'
        },
        "employment_address": {
          name: 'employment_address',
          type: 'string'
        },
        "employment_tel_number": {
          name: 'employment_tel_number',
          type: 'string'
        },
        "employment_location": {
          name: 'employment_location',
          type: 'string'
        },
        "marital_status": {
          name: 'marital_status',
          type: 'string'
        },
        "no_of_children": {
          name: 'no_of_children',
          type: 'string'
        },
        "referer_name": {
          name: 'referer_name',
          type: 'string'
        },
        "referer_contact": {
          name: 'referer_contact',
          type: 'string'
        },
        "next_of_kin_name": {
          name: 'next_of_kin_name',
          type: 'string'
        },
        "next_of_kin_relationship": {
          name: 'next_of_kin_relationship',
          type: 'string'
        },
        "next_of_kin_tel_number": {
          name: 'next_of_kin_tel_number',
          type: 'string'
        },
        "next_of_kin_address": {
          name: 'next_of_kin_address',
          type: 'string'
        },
        "current_landlord_name": {
          name: 'current_landlord_name',
          type: 'string'
        },
        "current_landlord_phone_number": {
          name: 'current_landlord_phone_number',
          type: 'string'
        },
        "current_landlord_address": {
          name: 'current_landlord_address',
          type: 'string'
        },
        "bank_name": {
          name: 'bank_name',
          type: 'string'
        },
        "account_number": {
          name: 'account_number',
          type: 'string'
        },
        "kra_pin": {
          name: 'kra_pin',
          type: 'string'
        },
        "user_category": {
          name: 'user_category',
          type: 'string'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'AccessToken[]',
          model: 'AccessToken',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        roles: {
          name: 'roles',
          type: 'Role[]',
          model: 'Role',
          relationType: 'hasMany',
          modelThrough: 'RoleMapping',
          keyThrough: 'roleId',
          keyFrom: 'id',
          keyTo: 'principalId'
        },
        land_lord_properties: {
          name: 'land_lord_properties',
          type: 'CompanyAccount[]',
          model: 'CompanyAccount',
          relationType: 'hasMany',
          modelThrough: 'PropertyOwner',
          keyThrough: 'property_id',
          keyFrom: 'id',
          keyTo: 'property_owner_id'
        },
        property_units: {
          name: 'property_units',
          type: 'PropertyUnits[]',
          model: 'PropertyUnits',
          relationType: 'hasMany',
          modelThrough: 'TenantUnit',
          keyThrough: 'property_unit_id',
          keyFrom: 'id',
          keyTo: 'tenant_id'
        },
        properties: {
          name: 'properties',
          type: 'CompanyAccount[]',
          model: 'CompanyAccount',
          relationType: 'hasMany',
          modelThrough: 'TenantUnit',
          keyThrough: 'property_id',
          keyFrom: 'id',
          keyTo: 'tenant_id'
        },
        tenant_unit: {
          name: 'tenant_unit',
          type: 'TenantUnit[]',
          model: 'TenantUnit',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'tenant_id'
        },
        tenants_check_list: {
          name: 'tenants_check_list',
          type: 'CheckList[]',
          model: 'CheckList',
          relationType: 'hasMany',
          modelThrough: 'TenantCheckList',
          keyThrough: 'checkListId',
          keyFrom: 'id',
          keyTo: 'tenant_id'
        },
        tenant_deposit: {
          name: 'tenant_deposit',
          type: 'TenantDeposit[]',
          model: 'TenantDeposit',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'tenant_id'
        },
        vendorCategories: {
          name: 'vendorCategories',
          type: 'VendorCategories',
          model: 'VendorCategories',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'vendor_category_id'
        },
        tenantLease: {
          name: 'tenantLease',
          type: 'Lease[]',
          model: 'Lease',
          relationType: 'hasMany',
          modelThrough: 'TenantLease',
          keyThrough: 'lease_id',
          keyFrom: 'id',
          keyTo: 'tenant_id'
        },
        landlordDetails: {
          name: 'landlordDetails',
          type: 'LandlordDetails',
          model: 'LandlordDetails',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'land_lord_id'
        },
        roleMappings: {
          name: 'roleMappings',
          type: 'RoleMapping[]',
          model: 'RoleMapping',
          relationType: 'hasMany',
          modelThrough: 'RoleMapping',
          keyThrough: 'roleMappingId',
          keyFrom: 'id',
          keyTo: 'principalId'
        },
      }
    }
  }
}
